module.exports = __webpack_public_path__ + "img/222.a7a2174.a7a21749.png";